import { render, staticRenderFns } from "./page-plan.vue?vue&type=template&id=755b2e6c&scoped=true&"
import script from "./page-plan.vue?vue&type=script&lang=js&"
export * from "./page-plan.vue?vue&type=script&lang=js&"
import style0 from "./page-plan.vue?vue&type=style&index=0&id=755b2e6c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755b2e6c",
  null
  
)

export default component.exports